var styles = {"article":"IconText-module_article__hc8xy","is-selected":"IconText-module_is-selected__qqVQ0","icon":"IconText-module_icon__58zvW","badge":"IconText-module_badge__qB0iP","type-new":"IconText-module_type-new__M-H-o"};

export { styles as default };
